import {
  IEmployeeData,
  IEmployeeWorkScheduleData,
  IHrDepartmentData,
  IUserData
} from '@/models';
import {
  IEmployeeFetchParams,
  IEmployeePaginatedListData,
  IEmployeeService
} from './employee.types';
import { EMPLOYEE_EXPORT_XLSX_TIMEOUT } from './employee.constant';
import { AxiosInstance } from 'axios';

export class EmployeeService implements IEmployeeService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/employees/';
  }
  fetchSalaryEmployeeUsers(): Promise<IUserData[]> {
    return this.axios
      .get<IUserData[]>(`${this.endpoint}get_users/`)
      .then(({ data }) => data);
  }

  fetchEmployees(
    params: IEmployeeFetchParams
  ): Promise<IEmployeePaginatedListData | IEmployeeData[]> {
    return this.axios
      .get<IEmployeePaginatedListData | IEmployeeData[]>(`${this.endpoint}`, {
        params
      })
      .then(({ data }) => data);
  }

  fetchEmployee(id: number): Promise<IEmployeeData> {
    return this.axios
      .get<IEmployeeData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createEmployee(data: IEmployeeData): Promise<IEmployeeData> {
    return this.axios
      .post<IEmployeeData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateEmployee(data: IEmployeeData): Promise<IEmployeeData> {
    return this.axios
      .patch<IEmployeeData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteEmployee(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }

  exportEmployeesXLSX(year: number): Promise<Blob> {
    return this.axios
      .get(`${this.endpoint}export/`, {
        params: { year },
        responseType: 'blob',
        timeout: EMPLOYEE_EXPORT_XLSX_TIMEOUT
      })
      .then(({ data }) => data);
  }

  uploadHourlyEmployees(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.axios
      .post<void>(`${this.endpoint}import-data/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 1000 * 60 * 5 //5mins,
      })
      .then(({ data }) => data);
  }

  // Work Schedule
  fetchEmployeeWorkSchedule(
    employeeId: number
  ): Promise<IEmployeeWorkScheduleData> {
    return this.axios
      .get<IEmployeeWorkScheduleData>(`${this.endpoint}${employeeId}/schedule/`)
      .then(({ data }) => data);
  }

  createEmployeeWorkSchedule(
    data: IEmployeeWorkScheduleData
  ): Promise<IEmployeeWorkScheduleData> {
    return this.axios
      .post<IEmployeeWorkScheduleData>(
        `${this.endpoint}${data.employee}/schedule/`,
        data
      )
      .then(({ data }) => data);
  }

  updateEmployeeWorkSchedule(
    data: IEmployeeWorkScheduleData
  ): Promise<IEmployeeWorkScheduleData> {
    return this.axios
      .patch<IEmployeeWorkScheduleData>(
        `${this.endpoint}${data.employee}/schedule/`,
        data
      )
      .then(({ data }) => data);
  }

  deleteEmployeeWorkSchedule(employeeId: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${employeeId}/schedule/`);
  }

  fetchEmployeeTeamDepartments(
    employeeId: number
  ): Promise<IHrDepartmentData[]> {
    return this.axios
      .get<IHrDepartmentData[]>(
        `${this.endpoint}${employeeId}/departments-overseen/`
      )
      .then(({ data }) => data);
  }
}
